import GhostDescription from '@common/GhostDescription';
import { InlineEditableInput } from '@common/styles/InlineEditableInput';
import { theme } from '@prophecy/theme';
import { GhostInput, Stack } from '@prophecy/ui-v3';
import { validateEntityName } from '@prophecy/utils/validation';
import { useEffect } from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';

import { BasicFormData } from '../types';

const BasicForm = ({
  teamId,
  formContext,
  updateTeamErrors
}: {
  teamId?: string;
  formContext: UseFormReturn<BasicFormData>;
  updateTeamErrors: (e: boolean) => void;
}) => {
  const {
    control,
    formState: { errors, isValid }
  } = formContext;

  useEffect(() => {
    updateTeamErrors(!isValid);
  }, [updateTeamErrors, isValid]);

  const InputField = teamId ? InlineEditableInput : GhostInput;

  return (
    <>
      <Stack align='start'>
        <Stack align='start' gap={theme.spaces.x12} direction='vertical' padding={`0 ${theme.outlineWidth}`}>
          <Controller
            render={({ field }) => (
              <InputField
                placeholder='Enter team name'
                inputSize='l'
                disabled={!!teamId}
                {...field}
                variant={errors.name ? 'error' : 'primary'}
                helpText={errors.name?.message}
                data-test-id='team-basic-form-name-input'
              />
            )}
            control={control}
            name='name'
            rules={{
              required: 'Name is required',
              validate: validateEntityName
            }}
          />
          <Controller
            render={({ field }) => <GhostDescription value={field.value as string} onChange={field.onChange} />}
            control={control}
            name='description'
          />
        </Stack>
      </Stack>
    </>
  );
};

export default BasicForm;
